import { useState } from "react";
import { Button, ModalDelete } from "expano-components";
import { Dashboard } from "components";
import useDelete from "hooks/useDelete";
import { url } from "utils/api";

import AddDocumentModal from "./components/AddDocumentModal";
import EditDocumentModal from "./components/EditDocumentModal";

const DocumentProductGroups = ({ product_group_id, refetch, data }) => {
  const [is_open_modal, setOpenModal] = useState(false);
  const [document_to_delete, setDocumentToDelete] = useState(null);
  const [document_to_edit, setDocumentToEdit] = useState(null);

  const { is_deleting, _delete } = useDelete({
    path: `/document_product_groups/${document_to_delete?.id}`,
  });

  const handleDelete = async () => {
    await _delete();
    refetch();
    setDocumentToDelete(null);
  };

  return (
    <Dashboard
      header={{
        icon: "info",
        title: "Dokumenty",
      }}
      footer={
        <Button
          type="add"
          text="Dodaj dokument"
          onClick={() => setOpenModal(true)}
        />
      }
    >
      {is_open_modal && (
        <AddDocumentModal
          product_group_id={product_group_id}
          refetch={refetch}
          handleClose={() => setOpenModal(false)}
        />
      )}
      {document_to_edit?.id && (
        <EditDocumentModal
          id={document_to_edit?.id}
          initialValues={{ name: document_to_edit?.name }}
          refetch={refetch}
          handleClose={() => setDocumentToEdit(null)}
        />
      )}
      {document_to_delete?.id && (
        <ModalDelete
          name={`dokument „${document_to_delete?.name}”?`}
          handleDelete={handleDelete}
          handleClose={() => setDocumentToDelete(null)}
        />
      )}
      {data?.length > 0 && (
        <table className="table">
          <tbody className="table__body table-body">
            {data.map(({ id, name, lang, file }) => (
              <tr key={id}>
                <td>
                  <span className="m-r-10" style={{ color: "#595D6E" }}>
                    {lang}
                  </span>
                  <a
                    className="text-link"
                    href={`${url}${file}`}
                    target="_blank"
                    rel="noreferrer"
                  >
                    {name}
                  </a>
                </td>
                <td width={80}>
                  <div className="row ai-c">
                    <Button
                      type="edit"
                      onClick={() =>
                        setDocumentToEdit({
                          id,
                          name,
                        })
                      }
                    />
                    <Button
                      disabled={is_deleting}
                      type="delete-bin"
                      onClick={() =>
                        setDocumentToDelete({
                          id,
                          name,
                        })
                      }
                    />
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </Dashboard>
  );
};

export default DocumentProductGroups;
